module.exports = {
          srcSet: __webpack_public_path__ + "6f0fd44338fb9b6fd601f5fe4cedecb1-1647.png"+" 1647w",
          images:[ {path: __webpack_public_path__ + "6f0fd44338fb9b6fd601f5fe4cedecb1-1647.png",width: 1647,height: 2886}],
          src: __webpack_public_path__ + "6f0fd44338fb9b6fd601f5fe4cedecb1-1647.png",
          toString:function(){return __webpack_public_path__ + "6f0fd44338fb9b6fd601f5fe4cedecb1-1647.png"},
          
          width: 1647,
          height: 2886
        }